/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.InboxStatusChageRequest) => void,
  (requestParams: vp.InboxStatusChageRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostRejectApprovalTransaction({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.InboxStatusChageRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.InboxStatusChageRequest, cancelTokenSource: CancelTokenSource) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postRejectApprovalTransation(requestParams, cancelTokenSource);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.InboxStatusChageRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.InboxStatusChageRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postRejectApprovalTransation(requestParams, source);
      setDataFetchingInfo(false);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostRejectApprovalTransaction);
